import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { DropdownSelectPropTypes } from 'src/interfaces/iproptypes';

const DropdownSelect = ({ name, value, setValue, options }: DropdownSelectPropTypes) => {
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <InputLabel>{name}</InputLabel>
      <Select value={value} label={name} onChange={handleChange}>
        {Object.entries(options).map(([optionKey, optionLabel]) => (
          <MenuItem value={optionKey} key={optionKey}>
            {optionLabel}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropdownSelect;
